import React, {useEffect} from 'react';

import {Compose, ComposeSettings} from "../../../../../core/components/composers/compose";
import {Popup} from "../../../../../core/components/misc/dialog/popup";
import {BettingPromotionModuleController} from "../betting-promotion.module.controller";
import classNames from "classnames";
import {BaseProps} from "../../../../../infrastructure/models/props/base-props";
import {BETTING_PROMOTION} from "../bettin-ptomotion.module.consts";
import {BettingPromotionModuleContent} from "./betting-promotion.module.content";
import {Image} from "../../../../../core/components/image/image";
import styles from "../styles/betting-promotion.module.scss"
import {useThemeColor} from "../../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../../../core/app/consts/colors";

export class BettingPromotionModuleProps extends BaseProps {}

export const BettingPromotionModuleComponent = ({controller}) => {
  const {state, device} = controller;
  const {isPopup, isBanner, imageUrl, bookie, logoHeight} = state;
  const {bookmakerLogo, backgroundColor} = bookie;
  const {isSmallView} = device;

  useEffect(() => {controller.action(BETTING_PROMOTION.ACTION_TYPES.ANALYTICS.onDisplayHandler)}, []);

  const popupProp = {
    className: classNames(
      {[styles.popup]: isPopup},
      {[styles.banner]: isBanner},
      {[styles.small_View]: isSmallView}
    ),
    style: {
      backgroundImage: isBanner ? `url(${imageUrl})` : 'initial',
      backgroundColor
    },
    shouldRenderClearButton: true,
    clearButtonColor: useThemeColor(COLORS.whitePrimary),
    onClose: () => controller.action(BETTING_PROMOTION.ACTION_TYPES.onPopupClick, {type: BETTING_PROMOTION.CLICK_TYPE.clear})
  }

  const imageProps = {
    src: imageUrl,
    className: classNames(styles.content_image)
  }

  const logoProps = {
    src: new bookmakerLogo.transparentLogoType({height: logoHeight}, {id: bookmakerLogo.id}),
    className: classNames(styles.bookie_logo),
    style: {
      width: 'auto',
      height: logoHeight
    }
  }

  return (
    <Popup {...popupProp}>
      <Image {...logoProps}/>
      {
        !isBanner ? <Image {...imageProps}/> : null
      }
      <BettingPromotionModuleContent controller={controller}/>
    </Popup>
  )
};

const settings: ComposeSettings = {
  component: BettingPromotionModuleComponent,

  observe: true,
  createModule: true,
  propsType: BettingPromotionModuleProps,
  controllerType: BettingPromotionModuleController
};

export default Compose(settings);

